import { useState } from 'react';

const faqs = [
  {
    q: '问鼎下载上的软件都是正版吗？',
    a: '是的，问鼎下载平台上的所有软件、游戏和应用均经过严格的正版授权审核。我们与国内外知名软件厂商建立了深度合作关系，确保每一款资源均为官方正版，杜绝盗版和恶意修改版本。',
  },
  {
    q: '下载软件需要付费吗？',
    a: '问鼎下载平台提供海量免费正版软件下载服务。部分商业软件可能为试用版或需购买授权，我们会在软件详情页明确标注。免费软件完全免费，无隐藏收费。',
  },
  {
    q: '下载速度慢怎么办？',
    a: '问鼎下载采用多线CDN加速和智能节点调度技术，自动为您匹配最快的下载线路。如遇到下载速度慢的情况，可以尝试切换下载线路，或使用问鼎下载客户端获得更稳定的下载体验。',
  },
  {
    q: '下载的文件安全吗？会不会有病毒？',
    a: '安全是我们的首要承诺。所有上架资源均经过360、腾讯等多家安全引擎交叉扫描检测，确保无病毒、无木马、无恶意插件。我们为每一款资源提供安全检测报告。',
  },
  {
    q: '支持哪些操作系统平台？',
    a: '问鼎下载全面支持Windows、macOS、Android、iOS等主流操作系统平台。您可以根据自己的设备类型筛选对应平台的资源，我们也会自动识别您的系统推荐匹配版本。',
  },
  {
    q: '如何联系客服获取帮助？',
    a: '您可以通过以下方式联系我们：发送邮件至 contact@wendingxiazai.com，或拨打客服热线 400-888-6666（工作日 9:00-18:00）。也可以访问我们的"关于我们"页面获取更多联系方式。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-base">
            关于问鼎下载，您可能想了解的问题
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}